<template>
  <div class="order-compare">
    <el-row class="order-compare-title">
      <el-col :span="3">
        <span class="h3">{{$t('dui_bi_fen_xi')}}</span>
      </el-col>
      <el-col :span="10">
        <div class="order-device-area">
          <span class="label">{{$t('fen_zu_dui_bi')}}</span>
          <!--          <span class="span" @click="handleAddGroupVisible"><i class="iconfont icon-tianjia"></i> {{$t('xin_zeng_fen_zu')}}</span>-->
          <!--          <div class="area-group-container">-->
          <!--            <el-tag-->
          <!--              v-for="(tag, index) in userGroups"-->
          <!--              :key="tag.name"-->
          <!--              effect="plain"-->
          <!--              size="mini"-->
          <!--              @close="handleGroupClose(index)"-->
          <!--              closable>-->
          <!--              {{tag.name}}-->
          <!--            </el-tag>-->
          <!--          </div>-->
          <el-form :inline="true">
            <el-form-item label="A">
              <el-select v-model="AGroup.groups" multiple :placeholder="$t('a_group')">
                <el-option :label="g.name" :value="g.uuid" v-for="(g,k) in selectGroups" :key="k"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="B">
              <el-select v-model="BGroup.groups" multiple :placeholder="$t('b_group')">
                <el-option :label="g.name" :value="g.uuid" v-for="(g,k) in selectGroups" :key="k"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </el-col>

      <el-col :span="8" class="area-group">
        <span class="span"> {{$t('shi_jian_wei_du')}} </span>
        <div class="area-group-filter">
          <el-date-picker
            size="mini"
            :format="dateFmt"
            v-model="date"
            :type="type"
            :placeholder="$t('xuan_qu_ri_qi')">
          </el-date-picker>
          <span class="time" :class="type==='year'?'active':'' "
                @click="handleChangeLabel('year')">{{$t('nian')}}</span>
          <span class="time" :class="type==='month'?'active':'' "
                @click="handleChangeLabel('month')">{{$t('yue')}}</span>
          <span class="time" :class="type==='date'?'active':'' " @click="handleChangeLabel('date')">{{$t('ri')}}</span>
        </div>
      </el-col>
      <el-col :span="1">
        <el-button type="primary" size="mini" @click="handleAnalyze"> {{$t('kai_shi_fen_xi')}}</el-button>
      </el-col>
    </el-row>

    <c-dialog :visible.sync="groupVisible" :width="'36rem'" :height="'36rem'" :title="$t('xin_zeng_fen_zu')">
      <el-button slot="title" size="mini" type="primary" @click="handleAddGroup">{{$t('bao_cun')}}</el-button>
      <div class="select-data">
        <el-form label-width="auto">
          <el-form-item :label="$t('fen_zu_ming_chen')">
            <el-input :placeholder="$t('qing_shu_ru_fen_zu_ming_chen')" v-model="userGroup.name"></el-input>
          </el-form-item>
        </el-form>
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane :label="$t('xuan_qu_fen_zu')" name="group">
            <el-transfer
              :titles="[$t('suo_you_fen_zu'), $t('yi_xuan_fen_zu')]"
              filterable
              :filter-method="filterMethod"
              :filter-placeholder="$t('qing_shu_ru_fen_zu_ming_chen')"
              v-model="userGroup.groups"
              :data="selectGroups">
            </el-transfer>
          </el-tab-pane>
          <el-tab-pane :label="$t('xuan_qu_she_bei')" name="device">
            <el-transfer
              :titles="[$t('suo_you_she_bei'), $t('yi_xuan_she_bei')]"
              filterable
              :filter-method="filterMethod"
              :filter-placeholder="$t('qing_shu_ru_she_bei_ming_chen')"
              v-model="userGroup.devices"
              :data="selectDevices">
            </el-transfer>
          </el-tab-pane>
        </el-tabs>

      </div>

    </c-dialog>

    <div class="order-compare-echart" id="orderCompare">
    </div>

  </div>

</template>

<script>
  import {groupAll} from '@/api/delivery/organization/group'
  import {deviceAll} from '@/api/delivery/device/list'
  import {orderCompare} from '@/api/delivery/order/order'
  import CDialog from '@/components/Dialog'

  import echarts from 'echarts'
  import bar from './echart.js'


  export default {
    name: '',
    components: {
      CDialog
    },
    mounted: function () {
      let vue = this
      groupAll().then(res => {
        vue.selectGroups = res.data || []
      })

      deviceAll().then(res => {
        res.data.forEach((device, index) => {
          vue.selectDevices.push({
            label: device.name,
            key: device.uuid,
          });
        });
      })
      this.date = new Date()
      this.barOpt.yAxis[0].name = this.$t('bei')
      this.barOpt.yAxis[1].name = this.$t('yuan')
      switch (this.type) {
        case "month":
          this.barOpt.xAxis.name = ' ' +this.$t('ri')
          break
        case "year":
          this.barOpt.xAxis.name = ' ' +this.$t('yue')
          break
      }
      this.init()
    },
    data: function () {
      return {
        barOpt: bar,
        saleBarOpt: bar,
        date: '',
        activeName: 'group',
        dateFmt: 'yyyy-MM',
        type: 'month',
        makeTimeRange: [],
        userGroups: [],
        userGroup: {
          name: '',
          devices: [],
          groups: [],
        },
        AGroup: {
          name: 'A',
          devices: [],
          groups: [],
        },
        BGroup: {
          name: 'B',
          devices: [],
          groups: [],
        },
        selectGroups: [],
        selectDevices: [],
        groupVisible: false,
        deviceVisible: false,
        chart: null,
        saleChart: null,
      }
    },
    methods: {
      handleChangeLabel(value) {
        this.type = value
        switch (value) {
          case "year":
            this.dateFmt = 'yyyy'
            break;
          case "month":
            this.dateFmt = 'yyyy-MM'
            break;
          case "date":
            this.dateFmt = 'yyyy-MM-dd'
            break;
        }
      },
      handleAddGroupVisible() {
        this.userGroup.devices = []
        this.userGroup.groups = []
        this.userGroup.name = ''
        this.groupVisible = true
      },
      handleAnalyze() {
        if (!this.AGroup.groups || !this.BGroup.groups) {
          this.$message.warning('请选取需要对比的分组')
          return
        }
        let t = 0
        let year = this.date.getFullYear()
        let month = this.date.getMonth() + 1
        let day = this.date.getDate()
        let dateLen = 1
        this.barOpt.yAxis[0].name = this.$t('bei')
        this.barOpt.yAxis[1].name = this.$t('yuan')
        switch (this.type) {
          case "month":
            var d = new Date(year, month, 0);
            dateLen = d.getDate();
            t = 1
            this.barOpt.xAxis.name = ' ' +this.$t('ri')
            break
          case "year":
            this.barOpt.xAxis.name = ' ' +this.$t('yue')
            dateLen = 12
            t = 2
            break
        }
        let cups = []
        let sales = []
        let data = []
        let legendData = []
        for (let i = 1; i <= dateLen; i++) {
          data.push(i + this.barOpt.xAxis.name)
        }
        this.userGroups = []
        this.userGroups.push(this.AGroup, this.BGroup)
        for (let i = 0; i < this.userGroups.length; i++) {
          let name = this.userGroups[i].name
          let data = []
          let sData = []

          for (let i = 0; i < dateLen; i++) {
            data.push(0)
            sData.push(0)
          }
          legendData.push(name + this.$t('bei_liang'))
          cups.push({
            name: name + this.$t('bei_liang'),
            type: 'bar',
            data: data
          })
          legendData.push(name + this.$t('xiao_shou_e'))
          sales.push({
            name: name + this.$t('xiao_shou_e'),
            type: 'line',
            yAxisIndex: 1,
            data: sData
          })
        }
        this.barOpt.xAxis.data = data

        orderCompare({userGroups: this.userGroups, type: t, year: year, month: month, day: day}).then(res => {
          let data = res.data || []

          switch (t) {
            case 0:
              for (let i = 0; i < data.length; i++) {
                if (data[i] != null && data[i] !== undefined && data[i][0] !== undefined) {
                  cups[i].data[0] = data[i][0].orders
                  sales[i].data[0] = data[i][0].sale / 100
                }
              }
              break;
            case 1:
              for (let i = 0; i < data.length; i++) {
                if (data[i] !== undefined) {
                  let g = data[i] || []

                  for (let j = 0; j < g.length; j++) {
                    let idx = g[j].day - 1
                    cups[i].data[idx] = g[j].orders
                    sales[i].data[idx] = g[j].sale / 100
                  }
                }
              }
              break;
            case 2:
              for (let i = 0; i < data.length; i++) {
                if (data[i] !== undefined) {
                  let g = data[i] || []
                  for (let j = 0; j < g.length; j++) {
                    let idx = g[j].month - 1
                    cups[i].data[idx] = g[j].orders
                    sales[i].data[idx] = g[j].sale / 100
                  }
                }
              }
              break;
          }
          let serial = []

          for (let i = 0; i < cups.length; i++) {
            serial.push(cups[i])
          }

          for (let i = 0; i < sales.length; i++) {
            serial.push(sales[i])
          }
          this.barOpt.legend.data = legendData
          this.barOpt.series = serial
          this.chart.setOption(this.barOpt, true)
        })

      },

      handleAddGroup() {
        if (!this.userGroup.name) {
          this.$message.warning(this.$t('qing_shu_ru_fen_zu_ming_chen'))
          return
        }
        if (!this.userGroup.devices.length && !this.userGroup.groups.length) {
          this.$message.warning(this.$t('qing_xuan_qu_she_bei_huo_fen_zu'))
          return
        }
        this.userGroups.push({
          name: this.userGroup.name,
          devices: this.userGroup.devices,
          groups: this.userGroup.groups,
        })
        this.groupVisible = false
      },

      filterMethod(query, item) {
        return item.label.indexOf(query) > -1;
      },
      handleGroupClose(index) {
        this.userGroups.splice(index, 1);
      },
      init() {
        this.chart = echarts.init(document.getElementById('orderCompare'));
        this.chart.setOption(this.barOpt)
      }
    },
  }
</script>

<style lang="scss">
  .order-compare {
    padding: $padding $t-padding;
    display: flex;
    flex-direction: column;

    .order-device-area {
      .label {
        margin-right: 8px;
        font-size: 13px;
      }
    }

    .area-group {

      padding-right: $padding-5;
      margin-left: 8px;

      .time {
        border: 1px solid $f_color;
        padding: 2px;
        border-radius: 2px;
        margin-right: 8px;
        font-size: 12px;
        cursor: pointer;
      }

      .time.active, .time:hover {
        background-color: $f_color;
        color: #1f232b;
      }

      &-filter {
        margin-top: 8px;
      }
    }

    .span {
      font-size: 13px;
      cursor: pointer;
    }

    .area-group-container {
      background-color: #2B3139;
      height: 32px;
      padding: 6px 6px 0 6px;
      margin: 8px 8px 0 0;
      border-radius: 4px;

      .el-tag {
        height: 20px;
        line-height: 20px;
        background-color: #2a3039;
        border-color: $f_color;
        margin-right: 8px;
      }
    }

    .select-data {
      margin: $padding 0;

      .el-form-item__label {
        color: #c6c8cc;
      }

      .el-transfer {
        width: 500px;
        margin: auto;

        .el-transfer-panel {
          background-color: transparent;

          .el-transfer-panel__header {
            background-color: transparent;

            .el-checkbox__label {
              color: $f_color;
              font-size: .8rem;
            }
          }

          .el-transfer-panel__body {
            .el-transfer-panel__filter {
              .el-input__inner {
                border-radius: 0;
              }
            }

            .el-checkbox__label {
              color: $f_sec_color;
            }
          }
        }
      }
    }

    &-echart {
      margin-top: 16px;
      padding: 16px;
      border-radius: 8px;
      height: 560px;
      background-color: $bg_sec_color;
    }

  }

</style>
